import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { Report } from '../../services/api'
import { FindReportsQuery, ReportService } from '../../services/ReportService'

export interface ReportState {
  reports: Report[]
}

const initialState: ReportState = {
  reports: [],
}

export const doFetchReports = createAsyncThunk<Report[], FindReportsQuery>(
  'report/fetchReports',
  async (query) => {
    const response = await ReportService.findMany(query)
    return response
  },
)

export const reportReducer = createSlice({
  name: 'report',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doFetchReports.fulfilled, (state, action) => {
      state.reports = action.payload
    })
  },
})

export default reportReducer.reducer
